module.exports = __webpack_public_path__ + "img/42_35_440_002.75bb30fe.jpg";